import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {
  ChartsWidget7,
  ChartsWidget6,
  ChartsWidget5,
  MixedWidget8,
  ChartsWidget1,
  ChartsWidget3,
  ListsWidget5,
  TablesWidget5,
} from '../../../../../_metronic/partials/widgets'
import {GET} from '../../../../services/api'
//import { toastMessage } from '../../../helpers/toast'
import Swal from 'sweetalert2'
import {i18n} from '../../../../translate/i18n'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'

interface ISummaryData {
  created: string
}

interface ISummaryResponse {
  data: ISummaryData[]
  message: string
  success: boolean
  typemsg: string
}

// interface IProcessedData {
//   labels: string[]
//   datasets: {
//     label: string
//     data: number[]
//     backgroundColor: string[]
//     borderColor: string[]
//     borderWidth: number
//   }[]
// }

const SummarizeContent: FC = () => {
  const [, setSummary] = useState<ISummaryData[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchSummaryData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchSummaryData = async () => {
    try {
      const response = (await GET('/summarize/listSummaryUse')) as ISummaryResponse
      if (response.success) {
        setSummary(response.data)
        processData(response.data)
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao carregar dados',
          text: `não foi possível carregar os dados do resumo: ${response.message}`,
          confirmButtonText: 'OK',
          timer: 5000,
          timerProgressBar: true,
        })
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao carregar dados',
        text: 'Ocorreu um erro inesperado ao carregar os dados do resumo.',
        confirmButtonText: 'OK',
        timer: 5000,
        timerProgressBar: true,
      })
    } finally {
      setLoading(false)
    }
  }

  const processData = (data: ISummaryData[]) => {
    // Processar dados para os gráficos
    data.reduce((acc: any, curr) => {
      const date = new Date(curr.created).toLocaleDateString()
      acc[date] = (acc[date] || 0) + 1
      return acc
    }, {})

    // Mais processamentos conforme necessário
  }

  // const processChartData = (data: ISummaryData[]): IProcessedData => {
  //   // Agrupa por dia
  //   const dailyUsage = data.reduce((acc: {[key: string]: number}, curr) => {
  //     const date = new Date(curr.created).toLocaleDateString('pt-BR')
  //     acc[date] = (acc[date] || 0) + 1
  //     return acc
  //   }, {})

  //   // Ordena as datas
  //   const sortedDates = Object.keys(dailyUsage).sort(
  //     (a, b) => new Date(a).getTime() - new Date(b).getTime()
  //   )

  //   return {
  //     labels: sortedDates,
  //     datasets: [
  //       {
  //         label: 'Resumos por Dia',
  //         data: sortedDates.map((date) => dailyUsage[date]),
  //         backgroundColor: ['rgba(62, 151, 255, 0.2)'],
  //         borderColor: ['#3E97FF'],
  //         borderWidth: 2,
  //       },
  //     ],
  //   }
  // }
  return (
    <>
      <div>
        {loading ? (
          <div className='text-center'>Carregando dados...</div>
        ) : (
          <div className='card card-xl-stretch mb-5 mb-xl-8'>
            <div className='card-header'>
              <h3 className='card-title'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`summarize_ia.title`)}
                </span>
                <BreadCrumbs />
              </h3>
            </div>
            <div className='card-body'>
              <canvas id='summaryChart'></canvas>
            </div>
          </div>
        )}
      </div>
      <PageTitle breadcrumbs={[]}>Dashboard de Utilização</PageTitle>

      {/* Begin::Row */}
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-4'>
          <ChartsWidget7 className='card-xl-stretch mb-xl-8' />
        </div>

        <div className='col-xl-4'>
          <ChartsWidget6 className='card-xl-stretch mb-xl-8' />
        </div>

        <div className='col-xl-4'>
          <ChartsWidget5 className='card-xl-stretch mb-5 mb-xl-8' />
        </div>
      </div>
      {/* End::Row */}

      {/* Begin::Row */}
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-6'>
          <ChartsWidget1 className='card-xl-stretch mb-xl-8' />
        </div>

        <div className='col-xl-6'>
          <ChartsWidget3 className='card-xl-stretch mb-xl-8' />
        </div>
      </div>
      {/* End::Row */}

      {/* Begin::Row */}
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-6'>
          <ListsWidget5 className='card-xl-stretch mb-xl-8' />
        </div>

        <div className='col-xl-6'>
          <TablesWidget5 className='card-xl-stretch mb-5 mb-xl-8' />
        </div>
      </div>
      {/* End::Row */}

      {/* Begin::Row */}
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-12'>
          <MixedWidget8
            className='card-xl-stretch mb-xl-8'
            chartColor='primary'
            chartHeight='150px'
          />
        </div>
      </div>
      {/* End::Row */}
    </>
  )
}

const Summarize: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard de Utilização da IA', path: 'summarize', isActive: true},
          {title: i18n.t(`summarize_ia.summarize`), path: '/summarize', isActive: true},
        ]}
      >
        {i18n.t(`summarize_ia.summarize`)}
      </PageTitle>
      <SummarizeContent />
    </>
  )
}

export {Summarize}
